
export default function getGridButtonsData() {
    var gridButtons
    gridButtons =
        [
            {
                name: 'Minu pood',
                image: 'myDeals.svg',
                group: 'pood',
                role: 'seller',
                link: '/toolaud/pood',
            },

            {
                name: 'Poe tooted',
                image: 'book.svg',
                group: 'Teabekeskus',
                role: 'buyer',
                link: '/toolaud/tooted'
            },
            
            {
                name: 'Poe tellimused',
                image: 'myDeals.svg',
                group: 'tehingud',
                role: 'buyer',
                link: '/toolaud/tellimused',
            },
        ]
    return gridButtons

}